import { createFileRoute } from "@tanstack/react-router";

import ForgotPasswordPage from "@/admin/forgot-password/page";

export const Route = createFileRoute("/forgot-password")({
    component: RouteComponent,
});

function RouteComponent() {
    return <ForgotPasswordPage />;
}
